export function initVideoBlock(parent) {
  if (!parent) return;

  const player = parent.querySelector('media-player');
  const play = parent.querySelector('.video-block__play');

  play.addEventListener('click', () => player.play());

  player.addEventListener('play', () => {
    play.hidden = true;
  });

  player.addEventListener('pause', () => {
    play.hidden = false;
  });
}

export function initVideoBlocks(
  parent = document,
  selector = '.js-video-block',
) {
  parent.querySelectorAll(selector).forEach((block) => initVideoBlock(block));
}
